import React from 'react'
import PackageIcon from '../../../../../generic/icons/IconLib/PackageBoxIcon'
import ScalesIcon from '../../../../../generic/icons/IconLib/ScaleIcon'
import ShekelIcon from '../../../../../generic/icons/IconLib/ShekelIcon'
import TitleRow from '../../kosherTeudot/generic/TitleRow'
import TitleRowItem from '../../kosherTeudot/generic/TitleRowItem'
import styled from 'styled-components'

type Props = {
  prblemType: number
  requestQuantity: number
  quantity: number
  requestWeight: number
  weight: number
  requestPrice: number
  price: number
}

const ProblemQuantityRequest = ({
  prblemType,
  requestQuantity,
  quantity,
  requestWeight,
  weight,
  requestPrice,
  price
}: Props) => {

  if (prblemType === 3 || prblemType === 2 || prblemType === 1) {
    return (
      <TitleRow>
        <Wrapper $isWarning={!!(requestWeight && requestWeight !== weight)}>
          <TitleRowItem 
            name={`${requestWeight} / ${Number(weight)} ק"ג `}
            icon={<ScalesIcon />}
          />
        </Wrapper>
        {
          requestQuantity > 0 && (
            <Wrapper $isWarning={!!(requestQuantity && requestQuantity !== quantity)}>
              <TitleRowItem 
                name={`${requestQuantity} / ${quantity}`}
                icon={<PackageIcon />}
              />

            </Wrapper>
          )
        }
      </TitleRow>
    )
  } else if (prblemType === 4) {
    return (
      <TitleRow>
        <Wrapper $isWarning={!!(requestPrice && requestPrice !== price)}>
          <TitleRowItem 
            name={`${requestPrice} / ${price}`}
            icon={<ShekelIcon />}
          />
        </Wrapper>
      </TitleRow>
    )
  }
  
  return (
    <TitleRow>
      <Wrapper $isWarning={!!(requestWeight && requestWeight !== weight)}>
    <TitleRowItem 
      name={`${requestWeight} / ${Number(weight)} ק"ג `}
      icon={<ScalesIcon />}
    />
    </Wrapper>
    <Wrapper $isWarning={!!(requestPrice && requestPrice !== price)}>
      <TitleRowItem 
        name={`${requestPrice} / ${price}`}
        icon={<ShekelIcon />}
      />
    </Wrapper>
    <Wrapper $isWarning={!!(requestQuantity && requestQuantity !== quantity)}>
      <TitleRowItem 
        name={`${requestQuantity} / ${quantity}`}
        icon={<PackageIcon />}
      />
    </Wrapper>
  </TitleRow>
  )
}
const Wrapper = styled.div<{$isWarning?: boolean}>`
/* padding: 0.2em 0.5em; */

border-radius: 10px;
padding: 0 0.7em;
border-bottom: ${props => props.$isWarning ? '2px solid tomato' : 'transparent'};
color: ${props => props.$isWarning ? '#fff' : ''};
`
export default ProblemQuantityRequest